<template>
  <div class="form-container step2">
    <div class="loader" v-if="isLoading"></div>
    <form id="topup-energy-step2" @submit.prevent="submit" novalidate>
      <div class="topup-error" v-if="topupError">
        <h3>Podczas przetwarzania doładowania wystapił błąd!</h3>
        <p>Spróbuj ponownie lub skonsultuj się z&nbsp;pomocą techniczną.</p>
      </div>
      <div class="form-row">
        <div class="summary">
          <div class="logo">
            <img :src="getOperatorLogoSrc(operator)" :alt="operator">
          </div>
          <div class="data">
            <div class="zones">
              <div class="zone">
                <p class="zone-name" v-if="isManyZones">
                  1 strefa
                </p>
                <p class="zone-data">
                  <span>Kwota doładowania</span>
                  <span>{{ calculationData.highZoneValue.pln | pln }} PLN</span>
                </p>
                <p class="zone-data">
                  <span>Wykupiona ilość energii elektrycznej</span>
                  <span>{{ calculationData.highZoneValue.kwh }} kWh</span>
                </p>
              </div>

              <div class="zone" v-if="isManyZones">
                <p class="zone-name">
                  2 strefa
                </p>
                <p class="zone-data">
                  <span>Kwota doładowania</span>
                  <span>{{ calculationData.lowZoneValue.pln | pln }} PLN</span>
                </p>
                <p class="zone-data">
                  <span>Wykupiona ilość energii elektrycznej</span>
                  <span>{{ calculationData.lowZoneValue.kwh }} kWh</span>
                </p>
              </div>
            </div>
            <div class="amount-wrapper">
              <p>
                <span>Opłata transakcyjna</span>
                <span>{{ calculationData.transactionFee | pln }} PLN</span>
              </p>
              <p>
                <span>Wartość opłaty stałej</span>
                <span>{{ calculationData.constFee | pln }} PLN</span>
              </p>
              <p>
                <span>Wartość opłaty abonamentowej</span>
                <span>{{ calculationData.serviceFee | pln }} PLN</span>
              </p>
              <p v-if="calculationData.debt">
                <span>Spłata zadłużenia</span>
                <span>{{ calculationData.debt | pln }} PLN</span>
              </p>
              <p>
                <span>Kwota należności</span>
                <span>{{ calculationData.recalculatedAmount | pln }} PLN</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row form-buttons justify-content-between">
        <button type="button" class="btn btn-back" @click="goBack">Wstecz</button>
        <button type="submit" class="btn">Akceptuję i płacę</button>
      </div>
      <administrator-data-info />
    </form>
  </div>
</template>

<script>
import OperatorMixin from '@/doladujtutaj/mixins/operator.mixin'
import { mapMutations, mapState } from 'vuex'
import EnergySummary from '@/common/mixins/Topup/EnergySummary.mixin'
import AdministratorDataInfo from '@/doladujtutaj/components/AdministratorDataInfo'
import { ToolsClass } from '@/common/class/tools.class'

export default {
  name: 'TopupEnergyStep2',
  components: { AdministratorDataInfo },
  mixins: [
    EnergySummary,
    OperatorMixin
  ],
  computed: {
    ...mapState({
      operator: state => state.energy.checkData ? state.energy.checkData.operator : null
    })
  },
  methods: {
    ...mapMutations([
      'RESET_ENERGY_CALCULATION'
    ]),
    goBack () {
      this.RESET_ENERGY_CALCULATION()
    }
  },
  updated () {
    ToolsClass.sendHeightToIframeParent()
  }
}
</script>
